import { create } from "@/modules/core/store"
import { TemplateTypeFilter } from "@/modules/template/types/templateType"

type TemplatePageActions = {
  setPreviousProgramId: (previousProgramId: string | undefined) => void
  setSearchTerm: (searchTerm: string | undefined) => void
  setTemplateTypeFilter: (templateTypeFilter: TemplateTypeFilter) => void
}
type TemplatePageState = {
  previousProgramId: string | undefined
  searchTerm: string | undefined
  templateTypeFilter: TemplateTypeFilter
  actions: TemplatePageActions
}

const useTemplatePageStore = create<TemplatePageState>()((set) => ({
  previousProgramId: undefined,
  searchTerm: undefined,
  templateTypeFilter: TemplateTypeFilter.EXERCISE,
  actions: {
    setPreviousProgramId: (previousProgramId: string | undefined) => {
      set({ previousProgramId })
    },
    setSearchTerm: (searchTerm: string | undefined) => {
      set({ searchTerm })
    },
    setTemplateTypeFilter: (templateTypeFilter: TemplateTypeFilter) => {
      set({ templateTypeFilter })
    },
  },
}))
export const useTemplatePreviousProgramId = () => useTemplatePageStore((state) => state.previousProgramId)
export const useTemplatePageSearchTerm = () => useTemplatePageStore((state) => state.searchTerm)
export const useTemplatePageTemplateTypeFilter = () => useTemplatePageStore((state) => state.templateTypeFilter)
export const useTemplatePageActions = () => useTemplatePageStore((state) => state.actions)
